import { DATE_FORMATS, formatDate } from '@wix/da-i18next/pkg/time/functions';

export function parseDateString(dateStr: string): Date {
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function formatDisplayDate(dateStr: string, locale: string): string {
  const date = parseDateString(dateStr);
  return formatDate(date.toISOString(), DATE_FORMATS.Date.Full, locale);
}
